import axios from "axios";
import { getCookie, setCookie, removeCookie } from "./cookie";
// import { AddAgenciesDetail } from 'Pages/AddAgenciesDetail';

const header = () => ({
  headers: {
    "Content-Type": "application/json",
    "access-token": getCookie("pickAdminMyToken"),
  },
});

const formDataHeader = () => ({
  headers: {
    "Content-Type": "multipart/form-data",
    "access-token": getCookie("pickAdminMyToken"),
  },
});

//~ 토큰 재발급
const tokenReissue = async () => {
  const headers = {
    "refresh-token": getCookie("pickAdminRfToken"),
  };
  try {
    const result = await axios.get(`/v1/admin-page/auth/new-token`, {
      headers,
    });
    removeCookie("pickAdminMyToken", {
      path: "/",
    });
    setCookie("pickAdminMyToken", result?.data, {
      path: "/",
    });
    window.location.reload();
  } catch (error) {
    removeCookie("pickAdminRfToken");
    removeCookie("pickAdminMyToken");
    alert("로그인 세션이 만료되었습니다.\n다시 로그인해 주세요.");
    window.location.href = "/";
    return;
  }
};

//~ API Error Handling Function
const errorHandling = async (error) => {
  const { status } = error?.response;
  const { detail } = error?.response.data;
  switch (status) {
    case 401:
      if (detail === "Access Denied") return "accessDenied";
      else if (detail === "Please Add Days") return "addDays";
      else if (detail === "WrongID") return "wrongId";
      break;
    case 403:
      if (detail === "Access Token Expired") return await tokenReissue();
      else if (detail === `Incorrect Password`) return `wrongPw`;
      else if (detail === "LoginRequired") return "tokenExpired";
      else if (detail === "DuplicateLoginDetection") return "duplicateLogin";
      else if (detail === "Days Limit Exceeded") return "datePasses";
      else if (detail === "Expiration Date Exceeds limit")
        return "exceedCharOfDate";
      else if (detail === "Duplicated Id") return "duplicateId";
      else if (detail === "Retired User") return "retired";
      break;
    case 499:
      return "tokenError";
    case 500:
      return "serverError";
    case 404:
      return "notFound";
    case 501:
      if (detail === "IntegrityError") return "integrityError";
      break;
    case 504:
      return "renderErrorPage";
    default:
      return;
  }
};

//= 로그인
export const signIn = async (userId, userPw) => {
  try {
    return await axios.post(`/v1/admin-page/auth/login`, {
      user_id: userId,
      origin_password: userPw,
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

//= 전체 회원
export const getUserCount = async (target) => {
  try {
    return await axios.get(
      `/v1/admin-page/auth/user/count?filter_type=${target}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//= 출원 대행 카운트
export const getApplicationCount = async () => {
  try {
    return await axios.get(`/v1/admin-page/agency/dashboard`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//= 셀프 출원 카운트
export const getSelfApplicationCount = async () => {
  try {
    return await axios.get(`/v1/admin-page/self/dashboard`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//! 회원 리스트 조회
export const getUserList = async ({ page, limit }, filter_type, filter_val) => {
  try {
    return await axios.get(
      `/v1/admin-page/auth/user/accounts?page=${page}&limit=${limit}&filter_type=${filter_type}&filter_val=${filter_val}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//! 회원 정보 상세보기
export const getUserInfo = async (userId) => {
  try {
    return await axios.get(`/v1/admin-page/auth/user/info/${userId}`, header());
  } catch (error) {
    return await errorHandling();
  }
};

//! 일반 회원 탈퇴(비활성화) - is_active 값만 변경하는 소프트 비활성화
export const deactivateUsers = async (memberIds) => {
  try {
    return await axios.post(
      `/v1/admin-page/auth/user/deactivate`,
      { member_ids: memberIds },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};


// 쿠폰 리스트 조회
export const getCouponList = async ({
  page = 1,
  limit = 10,
  coupon_name = "",
  coupon_type = "",
  coupon_status = "",
  use_start_date = "",
  use_end_date = "",
  expired_start_date = "",
  expired_end_date = "",
}) => {
  try {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("limit", limit);

    if (coupon_name) params.append("coupon_name", coupon_name);
    if (coupon_type) params.append("coupon_type", coupon_type);
    if (coupon_status) params.append("coupon_status", coupon_status);
    if (use_start_date) params.append("use_start_date", use_start_date);
    if (use_end_date) params.append("use_end_date", use_end_date);
    if (expired_start_date) params.append("expired_start_date", expired_start_date);
    if (expired_end_date) params.append("expired_end_date", expired_end_date);

    return await axios.get(
      `/v1/admin-page/cs/coupon/list?${params.toString()}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};


//# 관리자 리스트 조회
export const getAdmin = async ({ page, limit }, filter_type, filter_val) => {
  try {
    return await axios.get(
      `/v1/admin-page/auth/admin/accounts?page=${page}&limit=${limit}&filter_type=${filter_type}&filter_val=${filter_val}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//# 관리자 정보 상세 보기
export const getAdminDetail = async (user_id) => {
  try {
    return await axios.get(
      `/v1/admin-page/auth/admin/info/${user_id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//# 관리자 등록
export const addAdmin = async (query) => {
  try {
    return await axios.post(
      `/v1/admin-page/auth/admin/signup`,
      query,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//# 관리자 수정
export const editAdmin = async (user_id, query) => {
  try {
    return await axios.post(
      `/v1/admin-page/auth/admin/modify/${user_id}`,
      query,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//# 관리자 아이디 중복 체크
export const idDuplicateCheck = async (user_id) => {
  try {
    return await axios.get(
      `/v1/admin-page/auth/admin/check/id-duplicates?user_id=${user_id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//# 관리자 단일 삭제
export const adminDelete = async (deleteId) => {
  try {
    return await axios.post(
      `/v1/admin-page/auth/admin/delete`,
      { user_pk: [deleteId] },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//# 관리자 다중 삭제
export const adminMultiDelete = async (deleteIdArr) => {
  try {
    return await axios.post(
      `/v1/admin-page/auth/admin/delete`,
      {
        user_pk: deleteIdArr,
      },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//& 공지사항 리스트 조회
export const getNoticeList = async (page, limit) => {
  try {
    return await axios.get(
      `/v1/admin-page/cs/notice?page=${page}&limit=${limit}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//& 공지사항 상세보기
export const getNoticeDetail = async (noticeId) => {
  try {
    return await axios.get(`/v1/admin-page/cs/notice/${noticeId}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//& 공지사항 단일 삭제
export const noticeDelete = async (data) => {
  try {
    return await axios.post("/v1/admin-page/cs/notice/delete", data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//& 공지사항 수정하기
export const noticeEdit = async (notice, formData) => {
  try {
    return await axios.put(
      `/v1/admin-page/cs/notice/edit/${notice}`,
      formData,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//& 공지사항 작성하기
export const noticeWrite = async (formData) => {
  try {
    return await axios.post(`/v1/admin-page/cs/notice`, formData, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// @ 문의 사항 불러오기
export const getInquiryList = async (page, limit, select, inquiryType) => {
  try {
    return await axios.get(
      `/v1/admin-page/cs/inquiry?page=${page}&limit=${limit}&answer=${select}&inquiry_type=${inquiryType}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};
// 필터링 관련 문의사항 불러오기 코드 임시로 주석 처리함
// 문의 사항이 정상적으로 로드 되지 않는 문제있음
// 위의 코드로 정상적으로 동작되지 않은 경우 사용
// const API_URL = '/v1/admin-page/cs/inquiry?page=${page}&limit=${limit}&answer=${select}&inquiry_type=${inquiryType}'

// export const getInquiryList = async (page, limit, select, inquiryType) => {
//   try {
//     const response = await axios.get(`${API_URL}/inquiries`, {
//       params: {
//         page,
//         limit,
//         select,
//         inquiryType: inquiryType !== "all" ? inquiryType : undefined // "all"일 경우 필터링하지 않음
//       }
//     });
//     return response;
//   } catch (error) {
//     return error;
//   }
// };

//@ 사이드바 신규 카운트 (최근 48시간)
export const getMenuNewCount = async () => {
  try {
    return await axios.get(`/v1/admin-page/menu/new-count`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 임의 문의글 작성 (관리자)
export const postAdminInquiry = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/inquiry`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 문의 사항 상세 조회
export const getInquiryDetail = async (inquiryId) => {
  try {
    return await axios.get(`/v1/admin-page/cs/inquiry/${inquiryId}`, header()); //
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 문의 사항 답변 등록
export const answerHandling = async (inquiryId, data) => {
  try {
    return await axios.put(
      `/v1/admin-page/cs/inquiry/answer/${inquiryId}`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 문의사항 삭제 API
// 임시 api 백엔드에서 수정 시 재수정 해야함!
export const inquiryDelete = async (data) => {
  try {
    return await axios.post("/v1/admin-page/cs/inquiry/delete", data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//============================ 고객 후기 게시판 (CS Review) ============================

//@ 후기 목록 조회 (관리자, 마스킹 없음 / 비회원 연락처 포함)
export const getReviewList = async (page, limit, reviewType, answer) => {
  try {
    const typeParam = reviewType
      ? `&review_type=${encodeURIComponent(reviewType)}`
      : "";
    return await axios.get(
      `/v1/admin-page/cs/review?page=${page}&limit=${limit}${typeParam}&answer=${answer}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 후기 상세 조회 (어드민 / 토큰 필요)
export const getCsReviewDetail = async (id) => {
  try {
    return await axios.get(`/v1/admin-page/cs/review/${id}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 임의 후기 작성 (운영용) → 201 { review_id }
export const postAdminReview = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/review`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 후기 수정 (작성자 무관 / body에 review_id 포함)
export const editReview = async (data) => {
  try {
    return await axios.put(`/v1/admin-page/cs/review/edit`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 후기 일괄 삭제 (soft delete)
export const deleteReviews = async (reviewIds) => {
  try {
    return await axios.post(
      `/v1/admin-page/cs/review/delete`,
      { review_ids: reviewIds },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 후기 답변 등록
export const postCsReviewAnswer = async (id, answer) => {
  try {
    return await axios.post(
      `/v1/admin-page/cs/review/${id}/answer`,
      { answer },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 후기 답변 수정
export const putCsReviewAnswer = async (id, answer) => {
  try {
    return await axios.put(
      `/v1/admin-page/cs/review/${id}/answer`,
      { answer },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//@ 후기 답변 삭제 (status_flag=false 복귀)
export const deleteCsReviewAnswer = async (id) => {
  try {
    return await axios.delete(
      `/v1/admin-page/cs/review/${id}/answer`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//# 블로그 전용 에러 핸들러
//  - 인증/토큰 관련(401/499, 403 중 토큰 관련 detail)은 공통 errorHandling에 위임 → 로그아웃/재발급 플로우
//  - 서버 오류(500/504)는 공통 처리
//  - 그 외(400/403 권한부족/404/409/422)는 원본 error를 throw → 페이지가 구체 메시지 토스트
const TOKEN_RELATED_403_DETAILS = new Set([
  "Access Token Expired",
  "LoginRequired",
  "DuplicateLoginDetection",
]);

const blogErrorHandling = async (error) => {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  if (status === 401 || status === 499 || status === 500 || status === 504) {
    return await errorHandling(error);
  }
  if (status === 403 && TOKEN_RELATED_403_DETAILS.has(detail)) {
    return await errorHandling(error);
  }
  throw error;
};

//# 블로그 카테고리 조회
export const getBlogCategories = async () => {
  try {
    return await axios.get(`/v1/admin-page/cs/blog/categories`, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

// key·section 은 생성 후 수정 불가. PUT 은 name·sort_order·is_active 만 받는다
export const createBlogCategory = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/blog/categories`, data, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

export const updateBlogCategory = async (categoryId, data) => {
  try {
    return await axios.put(`/v1/admin-page/cs/blog/categories/${categoryId}`, data, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

// 글(삭제된 글 포함)이 남은 카테고리는 409
export const deleteBlogCategory = async (categoryId) => {
  try {
    return await axios.delete(`/v1/admin-page/cs/blog/categories/${categoryId}`, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

//# 블로그 목록 조회
export const getBlogList = async ({ page, limit, status, category, keyword, section }) => {
  const params = new URLSearchParams();
  params.set("page", page);
  params.set("limit", limit);
  if (status && status !== "all") params.set("status", status);
  if (section && section !== "all") params.set("section", section);
  if (category && category !== "all") params.set("category", category);
  if (keyword) params.set("keyword", keyword);
  try {
    return await axios.get(
      `/v1/admin-page/cs/blog?${params.toString()}`,
      header()
    );
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

//# 블로그 상세 조회
export const getBlogDetail = async (postId) => {
  try {
    return await axios.get(`/v1/admin-page/cs/blog/${postId}`, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

//# 블로그 글 생성
export const createBlogPost = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/blog`, data, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

//# 블로그 글 수정 (PATCH 시맨틱: 변경할 필드만 포함)
export const updateBlogPost = async (postId, patchData) => {
  try {
    return await axios.put(
      `/v1/admin-page/cs/blog/${postId}`,
      patchData,
      header()
    );
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

//# 블로그 발행/발행취소 토글
export const togglePublishBlog = async (postId, publish) => {
  try {
    return await axios.post(
      `/v1/admin-page/cs/blog/${postId}/publish`,
      { publish },
      header()
    );
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

//# 블로그 다중 삭제 (소프트)
export const deleteBlogPosts = async (postIds) => {
  try {
    return await axios.post(
      `/v1/admin-page/cs/blog/delete`,
      { post_ids: postIds },
      header()
    );
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

//# 블로그 본문 이미지 업로드
export const uploadBlogImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    return await axios.post(
      `/v1/admin-page/cs/blog/upload-image`,
      formData,
      formDataHeader()
    );
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

//- 팝업 리스트 불러오기
export const getPopupList = async (pageInfo, status = "all") => {
  try {
    return await axios.get(
      `/v1/admin-page/cs/popup?page=${pageInfo.page}&limit=${pageInfo.limit}&status=${status}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//- 팝업 이미지 업로드
export const uploadPopupImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    return await axios.post(
      `/v1/admin-page/cs/popup/upload-file`,
      formData,
      formDataHeader()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//- 팝업 생성
export const createPopup = async (info) => {
  try {
    return await axios.post(`/v1/admin-page/cs/popup`, info, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//- 팝업 수정
export const editPopup = async (id, data) => {
  try {
    return await axios.put(
      `/v1/admin-page/cs/popup/edit/${id}`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//- 팝업 삭제
export const deletePopup = async (id) => {
  try {
    return await axios.delete(`/v1/admin-page/cs/popup`, {
      headers: {
        ...header(),
        "access-token": getCookie("pickAdminMyToken"),
      },
      data: {
        popup_ids: id,
      },
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 리스트
export const getAgenciesList = async (
  { page, limit },
  {
    markType,
    progress,
    applicantType,
    user_id,
    user_name,
    startDate,
    endDate,
    markName,
    sort,
  }
) => {
  try {
    return await axios.get(
      `/v1/admin-page/agency/list?mark_type=${markType}&progress_status=${progress}&applicant_type=${applicantType}&user_id=${user_id}&user_name=${user_name}&sort_order=${sort}&page=${page}&limit=${limit}
      ${startDate ? `&application_start_date=${startDate}` : ""}${endDate ? `&application_end_date=${endDate}` : ""
      }${markName ? `&mark_name=${markName}` : ""}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 다중 삭제
// 암사 api 백엔드에서 수정 시 재수정 해야함!
export const agenciesMultiDelete = async (applyAgentPks) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/delete`,
      applyAgentPks,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 조회
export const getAgenciesDetail = async (id) => {
  try {
    return await axios.get(
      `/v1/admin-page/agency/detail?apply_agent_pk=${id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 - 상표명 수정
export const editMarkName = async (id, data) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/mark-name?apply_agent_pk=${id}`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 - 진행 상태 수정
export const editProgress = async (id, progress) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/status?apply_agent_pk=${id}`,
      { progress_status: progress },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 - 결제 상태 수정
export const editPaidStatus = async (applyId, userId, paidStatus) => {
  try {
    return await axios.put(
      `/v1/admin-page/agency/payment-info/update?apply_agent_pk=${applyId}&user_pk=${userId}&paid_status_str=${paidStatus}`, // Query String Parameters에 전달할 요소들 백엔드 api에서 꼭 확인 후 작성
      {}, //request body 빈 객체 전달
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 - 상표 유형 수정
export const editMarkType = async (id, type) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/mark-type?apply_agent_pk=${id}`,
      { mark_type: type },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 - 출원 번호 등록
export const applyApplicationNumber = async (id, { first, middle, last }) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/application-number?apply_agent_pk=${id}`,
      { application_number: `${first}-${middle}-${last}` },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 - 출원 정보 가져오기
export const getApplicationInfo = async (id) => {
  try {
    return await axios.get(
      `/v1/admin-page/agency/application-information?apply_agent_pk=${id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};
// 출원 정보 삭제

export const deleteApplicationInfo = async (id) => {
  try {
    return await axios.delete(`/v1/admin-page/agency/application/delete`, {
      ...header(),
      data: id,
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 - 상품/업종 삭제
export const deleteProduct = async (data) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/delete-product`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 - 임시 결제 리스트
export const getPaymentTemp = async (id) => {
  try {
    return await axios.get(
      `/v1/admin-page/agency/payment-temp?apply_agent_pk=${id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//~ 출원 대행 상세 - 수동 결제 추가
// 추후 api 구성 후 다시 작성 예정
export const addManualPayment = async (id, data) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/payment-temp/add?apply_agent_pk=${id}`,
      {
        type: data.type,
        amount: data.amount,
        reason: data.reason,
        mark_class: data.mark_class || null,
      },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//* 셀프 출원 관리 리스트 조회
export const getSelfList = async (
  { page, limit },
  { markName, templateName, applicantName, startDate, endDate, markType }
) => {
  try {
    return await axios.get(
      `/v1/admin-page/self?page=${page}&limit=${limit}${markName ? `&mark_name=${markName}` : ""
      }${applicantName ? `&applicant_name=${applicantName}` : ""}${templateName ? `&template_name=${templateName}` : ""
      }${startDate ? `&start=${startDate?.replaceAll("-", "")}` : ""}${endDate ? `&end=${endDate?.replaceAll("-", "")}` : ""
      }${markType !== "all" ? `&mark_type=${markType?.toUpperCase()}` : ""}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//* 셀프 출원 관리 상세 조회
export const getSelfDetail = async (id) => {
  try {
    return await axios.get(
      `/v1/admin-page/self/detail?temp_id=${id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//* 셀프 출원 검토 요청 조회
export const getReviewRequest = async (
  { page, limit },
  { markName, templateName, applicantName, startDate, endDate, markType }
) => {
  try {
    return await axios.get(
      `/v1/admin-page/self/review-request/list?page=${page}&limit=${limit}${markName ? `&mark_name=${markName}` : ""
      }${applicantName ? `&applicant_name=${applicantName}` : ""}${templateName ? `&template_name=${templateName}` : ""
      }${startDate ? `&start=${startDate?.replaceAll("-", "")}` : ""}${endDate ? `&end=${endDate?.replaceAll("-", "")}` : ""
      }${markType !== "all" ? `&mark_type=${markType}` : ""}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//* 셀프 출원 디중 삭제
export const selfMultiDelete = async (data) => {
  try {
    return await axios.post("/v1/admin-page/self", data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

export const getUploadFile = async (formData) => {
  const headers = {
    "Content-Type": "multipart/form-data",
    "access-token": getCookie("pickAdminMyToken"),
  };

  try {
    return await axios.post(`/v1/admin-page/upload-files`, formData, {
      headers,
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

export const getFileDownload = async (fileName, originalFileName) => {
  try {
    return await axios.get("/v1/admin-page/get-common-file", {
      params: {
        file_name: fileName,
        original_file_name: originalFileName,
      },
      ...header(),
      responseType: "arraybuffer",
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

export const getResizeFileDownload = async (fileName, originalFileName) => {
  try {
    return await axios.get("/v1/admin-page/get-logo-image", {
      params: {
        file_name: fileName,
        original_file_name: originalFileName,
      },
      ...header(),
      responseType: "arraybuffer",
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

export const getReviewDetail = async (id) => {
  try {
    return await axios.get(
      `/v1/admin-page/self/review-request/detail?temp_id=${id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};
// 개인정보 파일 다운로드 및 저장
export const downloadPrivacyFile = async (fileName, originalFileName) => {
  try {
    const response = await axios.get("/v1/admin-page/get-privacy-file", {
      params: {
        file_name: fileName,
        original_file_name: originalFileName,
      },
      responseType: "blob", // 파일 응답
      ...header(), // 헤더 삽입
    });

    // blob 객체 생성
    const blob = new Blob([response.data]);

    // 브라우저용 URL 생성
    const downloadUrl = window.URL.createObjectURL(blob);

    // <a> 태그를 동적으로 만들어 다운로드 실행
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = decodeURIComponent(originalFileName); // 한글 파일명 대응
    document.body.appendChild(link);
    link.click();

    // 메모리 해제
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Error downloading privacy file:", error);
    throw error;
  }
};

export const getBrandNameList = async (page, limit, type) => {
  try {
    return await axios.get("/v1/admin-page/brand/history", {
      params: {
        page,
        limit,
        filter_data: type,
      },
      ...header(), // header() 함수 사용
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

//* 검토 요청 다중 삭제
export const requestMultiDelete = async (idsArray) => {
  try {
    return await axios.post(
      `/v1/admin-page/self/review-request/delete`,
      idsArray,
      {
        headers: {
          ...header(),
          "access-token": getCookie("pickAdminMyToken"),
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 추가 결제 요청
export const addPayment = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/added-payment`, data, header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// // 추가 결제 요청 조회
export const getAddPayment = async (apply_agent_pk) => {
  try {
    return await axios.get(
      `/v1/admin-page/added-payment?apply_agent_pk=${apply_agent_pk}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//  검토 요청 페이지 출원 검토 결과 등록, 수정
export const reviewRequestEdit = async (template_pk, data) => {
  try {
    return await axios.post(
      "/v1/admin-page/self/review-request",
      data,
      header() // 헤더는 세 번째 인자로 전달
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

export const checkNotification = async (data) => {
  try {
    return await axios.post(`/v1/agency/check-notification`, data, header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

export const searchProduct = async (mark_class, search_txt) => {
  try {
    return await axios.get(
      `/v1/agency/search-product?mark_class=${mark_class?.replace(
        "류",
        ""
      )}&search_text=${search_txt}`,
      header()
    );
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

export const postPaymentRefund = async (data) => {
  try {
    return await axios.post("/v1/admin-page/payments/refund", data, {
      ...header(),
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

export const getPaymentHistoryList = async (page, limit, status, keyword) => {
  try {
    return await axios.get("/v1/admin-page/payments/history", {
      params: {
        page: page,
        limit: limit,
        paid_status: status,
        keyword: keyword,
      },
      ...header(), // header() 함수 사용
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

// 출원번호, 출원일자 수정
export const editApplicatedDate = async (apply_agent_pk, app_num, app_date) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/application`,
      {
        apply_agent_pk: apply_agent_pk,
        application_number: app_num,
        applicated_at: app_date,
      },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 대행 페이지 상품/업종 및 출원유형 추가
export const addProduct = async (apply_agent_pk, data) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/update-product?apply_agent_pk=${apply_agent_pk}`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 대리인 정보 등록
export const addAgentInfo = async (apply_agent_pk, agentData) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/agent?apply_agent_pk=${apply_agent_pk}`,
      agentData,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 출원 정보등록 영역 첨부파일 삭제

export const deleteImg = async (id) => {
  try {
    return await axios.delete(
      `/v1/admin-page/agency/del-application-file/${id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 추가 결제 내역 삭제
export const deleteAddPayment = async (addPaymentPks) => {
  try {
    return await axios.post(
      `/v1/admin-page/added-payment/delete?added_payment_id=${addPaymentPks}`,
      {},
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 추가 결제 정보 변경
export const updateAddPayment = async (id, data) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/add-payment/update?add_payment_pk=${id}`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};
// 추가 결제 상태 변경
export const updateAddPaymentStatus = async (id, str) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/add-payment/status/update?add_payment_pk=${id}&paid_status_str=${str}`,
      {},
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 추가 결제 입금일자 변경
export const updateAddPaymentPaidAt = async (id, paidAt) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/add-payment/paid-at/update?add_payment_pk=${id}&paid_at=${paidAt}`,
      {},
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//= STEP 4 국가 코드 불러오기
export const getCountries = async () => {
  try {
    return await axios.get(`/v1/agency/get-country`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

//= STEP 4 국가 코드 검색
export const getCountry = async (searchTxt) => {
  try {
    return await axios.get(
      `/v1/agency/find-country?input_keyword=${searchTxt}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 등록대행 관리 신규 생성
export const addAgencyDetail = async (data) => {
  try {
    const response = await axios.post(`/v1/admin-page/agency`, data, header());
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 도장 생성
export const getStamp = async (pk) => {
  try {
    return await axios.get(`/v1/admin-page/rect-stamp?apply_agent_pk=${pk}`, {
      ...header(),
      responseType: "blob",
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

// 위임장 생성
export const getAttorney = async (pk) => {
  try {
    return await axios.post(
      `/v1/admin-page/attorney-document?apply_agent_pk=${pk}`,
      {},
      {
        ...header(),
        responseType: "blob",
      }
    );
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 대행 - 특허 고객 번호 등록
export const addCustomerNumber = async (data) => {
  try {
    return await axios.post(
      "/v1/admin-page/agency/patent-customer-number",
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

export const sendEmail = async ({ email, user_name, subject, email_type }) => {
  try {
    return await axios.post(
      "/v1/admin-page/email",
      {
        email,
        user_name,
        subject,
        email_type,
      },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 모든 사용자의 등록가능성 히스토리 조회
export const getPossibilityHistory = async (page, limit, key, val) => {
  try {
    return await axios.get("/v1/admin-page/tap/history", {
      params: {
        page,
        limit,
        filter_type: key,
        filter_val: val,
      },
      ...header(),
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

export const deleteAgentInfo = async (apply_agent_pk) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/agent/delete?apply_agent_pk=${apply_agent_pk}`,
      {},
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 위임장 파일 업로드
export const getAttorneyUploadFile = async (formData) => {
  const headers = {
    "Content-Type": "multipart/form-data",
    "access-token": getCookie("pickAdminMyToken"),
  };

  try {
    return await axios.post(`/v1/admin-page/upload-file/attorney`, formData, {
      headers,
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

// 도장 파일 업로드
export const getStampUploadFile = async (formData) => {
  const headers = {
    "Content-Type": "multipart/form-data",
    "access-token": getCookie("pickAdminMyToken"),
  };

  try {
    return await axios.post(
      `/v1/admin-page/upload-file/digital-stamp`,
      formData,
      {
        headers,
      }
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 저장한 도장 파일 다운로드
export const getStampDownload = async (pk) => {
  try {
    const response = await axios.get(
      `/v1/admin-page/download-file/digital-stamp/${pk}`,
      {
        ...header(),
        responseType: "blob",
      }
    );

    // 파일명 추출
    const contentDisposition = response.headers["content-disposition"];
    let filename = "digital_stamp.png"; // 기본 파일명 (스탬프는 보통 이미지 파일)

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, "");
      }
    }

    // Blob URL 생성 및 다운로드
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // 메모리 해제
    setTimeout(() => {
      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    }, 100);

    return response;
  } catch (error) {
    return await errorHandling(error);
  }
};

// 저장한 위임장 파일 다운로드
export const getAttorneyDownload = async (pk) => {
  try {
    const response = await axios.get(
      `/v1/admin-page/download-file/attorney/${pk}`,
      {
        ...header(),
        responseType: "blob",
      }
    );

    // 파일명 추출
    const contentDisposition = response.headers["content-disposition"];
    let filename = "attorney_document.pdf"; // 기본 파일명

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, "");
      }
    }

    // Blob URL 생성 및 다운로드
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // 메모리 해제
    setTimeout(() => {
      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    }, 100);

    return response;
  } catch (error) {
    return await errorHandling(error);
  }
};

// 출원번호-출원일자 추가
export const addApplicationNumber = async (data) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/application`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 출원번호 파일 업로드
export const getApplicationUploadFile = async (application_id, formData) => {
  const headers = {
    "Content-Type": "multipart/form-data",
    "access-token": getCookie("pickAdminMyToken"),
  };

  try {
    return await axios.post(
      `/v1/admin-page/agency/application/${application_id}/files`,
      formData,
      {
        headers,
      }
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 어드민 메모 불러오기
export const getAdminComment = async (target_type, target_id) => {
  try {
    return await axios.get(
      `/v1/admin-page/admin-comment?target_type=${target_type}&target_id=${target_id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

export const editTaxInvoiceStatus = async (apply_agent_pk, issued) => {
  try {
    const url = `/v1/admin-page/agency/tax-invoice-status?apply_agent_pk=${apply_agent_pk}`;
    const body = {
      tax_invoice_yn: issued ? "Y" : "N",
    };

    return await axios.put(url, body, header());
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 어드민 메모 작성하기
export const writeAdminComment = async (content) => {
  try {
    return await axios.post(`/v1/admin-page/admin-comment`, content, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 어드민 메모 삭제
export const deleteComment = async (id) => {
  try {
    return await axios.delete(`/v1/admin-page/admin-comment/${id}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 어드민 메모 수정
// 어드민 메모 수정 (텍스트만, JSON)
export const editComment = async (commentId, commentText) => {
  try {
    const body = { comment_text: (commentText ?? '').trim() };
    // comment_id는 query, 본문은 JSON
    return await axios.post(
      `/v1/admin-page/admin-comment/update?comment_id=${commentId}`,
      body,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};


// 메모 파일 업로드
export const getCommentUploadFile = async (comment_id, formData) => {
  const headers = {
    "Content-Type": "multipart/form-data",
    "access-token": getCookie("pickAdminMyToken"),
  };

  try {
    return await axios.post(
      `/v1/admin-page/admin-comment-file/${comment_id}`,
      formData,
      {
        headers,
      }
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 등록대행 파일 업로드
export const getAgencyUploadFile = async (apply_agent_pk, formData) => {
  const headers = {
    "Content-Type": "multipart/form-data",
    "access-token": getCookie("pickAdminMyToken"),
  };

  try {
    return await axios.post(
      `/v1/admin-page/agency/upload-privacy?apply_agent_pk=${apply_agent_pk}`,
      formData,
      {
        headers,
      }
    );
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 등록대행 파일 업로드 삭제
export const deleteAgencyFile = async (apply_agent_pk, file_gubun) => {
  try {
    return await axios.delete(
      `/v1/admin-page/agency/delete-privacy?apply_agent_pk=${apply_agent_pk}&file_gubun=${file_gubun}`,
      header()
    );
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 출원 정보 수정
export const editAplicationNumber = async (id, data) => {
  try {
    return await axios.put(
      `/v1/admin-page/agency/application/${id}`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 출원 정보 상품 추가
export const addApplicationItem = async (id, data) => {
  try {
    return await axios.post(
      `/v1/admin-page/agency/application/add-item/${id}`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

export const editApplicationItem = async (id, data) => {
  try {
    return await axios.put(
      `/v1/admin-page/agency/application/update-item/${id}`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

export const deleteApplicationItem = async (id, data) => {
  try {
    return await axios.delete(
      `/v1/admin-page/agency/application/delete-item/${id}`,
      {
        ...header(),
        data: data,
      }
    );
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 아이디 존재 여부
export const getIdExists = async (user_id) => {
  try {
    return await axios.get(`v1/auth/check/id-exists?user_id=${user_id}`);
  } catch (error) {
    return await errorHandling(error);
  }
};

// 결제 금액 수정
export const updatePrice = async (content) => {
  try {
    return await axios.post(
      `/v1/admin-page/order/update-price`,
      content,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//대행 xml 다운로드 기능
export const downloadXml = async (apply_agent_pk) => {
  try {
    return await axios.post(
      `/v1/admin-page/download-template?apply_agent_pk=${apply_agent_pk}`,
      {},
      {
        ...header(),
        responseType: "blob",
      }
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 출원정보 변경이력 조회
export const getApplyHistory = async (apply_agent_pk) => {
  try {
    const response = await axios.get(
      `/v1/admin-page/agent-apply-history/${apply_agent_pk}`,
      header()
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return {
        success: true,
        data: [],
        status: 404,
        message: "출원정보 변경이력이 없습니다.",
      };
    }

    const errorResult = await errorHandling(error);
    return {
      success: false,
      error: errorResult,
      status: error.response?.status,
      message: "출원정보 변경이력 조회 중 오류가 발생했습니다.",
    };
  }
};

// 출원정보 변경이력 상세 조회
export const getApplyHistoryDetail = async (id) => {
  try {
    return await axios.get(
      `/v1/admin-page/apply-agent-snapshot/group/${id}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 검토 요청 상태 변경
export const editReviewStatus = async (content) => {
  try {
    return await axios.post(
      `/v1/admin-page/self/review-request/status`,
      content,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 검토 요청 결제 상태 변경
export const editReviewPaidStatus = async (content) => {
  try {
    return await axios.post(
      `/v1/admin-page/self/review-request/order-status`,
      content,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 출원 정보 리스트 조회
export const getApplicationList = async (
  { page, limit },
  {
    progress,
    applicantType,
    applicationNum,
    user_id,
    user_name,
    markName,
    priority_review_yn, // 우선심사 여부 파라미터 추가
    sort,
    status,
  }
) => {
  try {
    // URL 파라미터 구성
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);

    if (progress && progress !== "all") params.append("status", progress);
    if (applicantType && applicantType !== "all")
      params.append("applicant_type", applicantType);
    if (applicationNum) params.append("application_number", applicationNum);
    if (user_id) params.append("user_id", user_id);
    if (user_name) params.append("user_name", user_name);
    if (markName) params.append("mark_name", markName);
    if (priority_review_yn && priority_review_yn !== "")
      params.append("priority_review_yn", priority_review_yn);
    if (sort) params.append("sort", sort);
    if (status) params.append("status", status);

    // URL과 파라미터 조합
    const url = `/v1/admin-page/agency/application/list?${params.toString()}`;

    console.log("API 요청 URL:", url); // 디버깅용

    return await axios.get(url, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 출원 정보 상세 조회
export const getApplicationDetailList = async (id) => {
  try {
    return await axios.get(`/v1/admin-page/agency/application/${id}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

export const searchCategoryDetail = async (
  offset,
  limit,
  mark_class,
  keyword
) => {
  try {
    return await axios.get(
      `/v1/admin-page/notified-product/by-mark-class/search?offset=${offset}&limit=${limit}&mark_class=${mark_class}&keyword=${keyword}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 검토 답변 삭제

export const deleteReviewAnswer = async (review_pk) => {
  try {
    return await axios.post(
      `/v1/admin-page/self/review-request/answer-delete?review_pk=${review_pk}`,
      {},
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// BIB 파싱용
export const parseBibData = async (formData) => {
  try {
    return await axios.post("/v1/admin-page/parse-bib-data", formData, {
      ...header(),
      headers: {
        ...header().headers,
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

// 유저 전용 파일 업로드 링크 생성
export const createFileLink = async (data) => {
  try {
    return await axios.post(
      `/v1/admin-page/create-file-request`,
      data,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 파일리스트
export const getFileList = async (page, limit, searchVal) => {
  try {
    return await axios.get(
      `/v1/admin-page/user-file-upload/list?page=${page}&limit=${limit}&user_name=${searchVal}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 도장 생성
export const getApplicationStamp = async (pk) => {
  try {
    return await axios.get(
      `/v1/admin-page/rect-stamp-apply?application_info_id=${pk}`,
      {
        ...header(),
        responseType: "blob",
      }
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 위임장 생성
export const getApplicationAttorney = async (pk) => {
  try {
    return await axios.post(
      `/v1/admin-page/attorney-document-apply?application_info_id=${pk}`,
      {},
      {
        ...header(),
        responseType: "blob",
      }
    );
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

//  공지사항 이미지 업로드

export const uploadNoticeImg = async (file) => {
  try {
    const formData = new FormData();
    formData.append("files", file);

    return await axios.post(`/v1/admin-page/upload-noti-files`, formData, {
      ...header(),
      headers: {
        ...header().headers,
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// FAQ 조회

export const getFaqList = async ({ page, limit }, category) => {
  try {
    return await axios.get(
      `/v1/cs/faq?page=${page}&limit=${limit}&category=${category}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// FAQ 생성
export const createFaq = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/faq`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// FAQ 상단 고정 수정
export const toggleFaqPin = async (id, pin) => {
  try {
    return await axios.post(
      `/v1/admin-page/cs/faq/update`,
      { faq_id: id, is_pinned: pin },
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// FAQ 전체 수정
export const updateFaq = async (faqId, data) => {
  return await axios.post(
    `/v1/admin-page/cs/faq/update`,
    {
      faq_id: faqId,
      category: data.category,
      question: data.question,
      answer: data.answer,
      is_active: data.is_active,
    },
    header()
  );
};

// FAQ 삭제
export const deleteFaq = async (faqIds) => {
  try {
    return await axios.post(
      `/v1/admin-page/cs/faq/delete`,
      faqIds, // 배열 형태: [1, 2, 3]
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

//FAQ 상세 조회

export const getFaqDetail = async (faqId) => {
  try {
    return await axios.get(
      `/v1/admin-page/cs/faq/detail?faq_id=${faqId}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 어드민 회원으로 로그인
export const adminLogin = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/impersonate-user`, data, header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 지급 쿠폰 생성         
export const createRewardCoupon = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/coupon`, data, header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 프로모션 쿠폰 생성
export const createPromotionCoupon = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/coupon/promotion`, data, header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};


export const getCouponDetail = async (id, coupon_code) => {
  try {
    return await axios.get(
      `/v1/admin-page/cs/coupon/detail?coupon_pk=${id}&coupon_code=${coupon_code}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};


// 전체 발급
export const adminIssueAllCoupons = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/coupon/issued-all`, data, header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 전체발급 취소
export const cancelIssueAllCoupons = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/coupon/issued-all-cancel`,
      data,
      header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 선택 발급 할 때 사용자 검색
export const getCouponSearchMember = async (user_name) => {
  try {
    return await axios.get(
      `v1/admin-page/cs/coupon/search-members?user_name=${user_name}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 선택발급
export const issuedCoupons = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/coupon/issued`,
      data,
      header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 쿠폰 삭제
export const deleteCoupon = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/coupon/delete`,
      data,
      header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};


// 쿠폰 수정
export const updateCoupon = async (coupon_pk, coupon_code, data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/coupon/update?coupon_pk=${coupon_pk}&coupon_code=${coupon_code}`,
      data,
      header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// 회원 선택해서 쿠폰 지급
export const createCouponMember = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/cs/coupon-member`,
      data,
      header());
  } catch (error) {
    await errorHandling(error);
    throw error;
  }
};

// ==========================================
// 업무 메모 API (Work Memo)
// ==========================================

// 메모 Entry 목록 조회
export const getWorkMemoList = async (page, limit, channel, status, keyword) => {
  try {
    let url = `/v1/admin-page/work-memo/entries?page=${page}&limit=${limit}`;
    if (channel) url += `&channel=${channel}`;
    if (status) url += `&status=${status}`;
    if (keyword) url += `&keyword=${encodeURIComponent(keyword)}`;
    return await axios.get(url, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 통합 타임라인 조회
export const getWorkMemoTimeline = async (page, limit, channel, status, keyword, itemType) => {
  try {
    let url = `/v1/admin-page/work-memo/timeline?page=${page}&limit=${limit}`;
    if (channel) url += `&channel=${channel}`;
    if (status) url += `&status=${status}`;
    if (keyword) url += `&keyword=${encodeURIComponent(keyword)}`;
    if (itemType) url += `&item_type=${itemType}`;
    return await axios.get(url, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 메모 상세 조회
export const getWorkMemoDetail = async (id) => {
  try {
    return await axios.get(`/v1/admin-page/work-memo/${id}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 메모 등록
export const createWorkMemo = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/work-memo`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 메모 수정
export const updateWorkMemo = async (id, data) => {
  try {
    return await axios.put(`/v1/admin-page/work-memo/${id}`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 메모 삭제 (전체)
export const deleteWorkMemo = async (id) => {
  try {
    return await axios.delete(`/v1/admin-page/work-memo/${id}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 메모 Entry 삭제 (개별)
export const deleteWorkMemoEntry = async (memoId, entryId) => {
  try {
    return await axios.delete(`/v1/admin-page/work-memo/${memoId}/entries/${entryId}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 메모 상태 변경
export const updateWorkMemoStatus = async (memoId, status) => {
  try {
    return await axios.patch(`/v1/admin-page/work-memo/${memoId}/status`, { status }, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 진행 메모 추가 (entry)
export const addWorkMemoEntry = async (memoId, data) => {
  try {
    return await axios.post(`/v1/admin-page/work-memo/${memoId}/entries`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 진행 메모 수정 (entry)
export const updateWorkMemoEntry = async (memoId, entryId, data) => {
  try {
    return await axios.put(`/v1/admin-page/work-memo/${memoId}/entries/${entryId}`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 고객명 자동완성
export const searchWorkMemoCustomer = async (keyword, limit = 10) => {
  try {
    return await axios.get(`/v1/admin-page/work-memo/autocomplete?keyword=${encodeURIComponent(keyword)}&limit=${limit}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 마크픽 회원 검색 (연결용)
export const searchUserForMemo = async (keyword, limit = 10) => {
  try {
    return await axios.get(`/v1/admin-page/work-memo/users/search?keyword=${encodeURIComponent(keyword)}&limit=${limit}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// ==========================================
// 매출 대시보드 API (Sales Dashboard)
// ==========================================

// 월별 매출 달력 조회
//   service: 'all' | 'trademark' | 'patent' | 'design'
export const getSalesCalendar = async (year, month, service = "all") => {
  try {
    return await axios.get(
      `/v1/admin-page/sales/calendar?year=${year}&month=${month}&service=${service}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 일별 매출 상세 조회
//   service: 'all' | 'trademark' | 'patent' | 'design'
export const getSalesDaily = async (date, page = 1, limit = 20, service = "all") => {
  try {
    return await axios.get(
      `/v1/admin-page/sales/daily?date=${date}&page=${page}&limit=${limit}&service=${service}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 연간 매출 추이 조회
//   service      : 'all' | 'trademark' | 'patent' | 'design'
//   compareYear  : 비교 연도. null 이면 compare 없이 응답
//   응답 형태 { meta, data: {
//     year, service,
//     months: [{ month, gross, refund, net, count, refund_rate, avg_ticket, pending_amount }],
//     compare: { year, months: [같은 형태] } | null,
//     ytd: { through_month, gross, net, compare_gross, compare_net },
//     available_years: [number]
//   } }
//   올해 요청 시 months 는 이번 달까지만 오고, ytd.through_month 는 완료된 달(이번 달 - 1)이다
export const getSalesTrend = async (year, service = "all", compareYear = null) => {
  try {
    const params = new URLSearchParams({ year, service });
    if (compareYear) params.append("compare_year", compareYear);
    return await axios.get(`/v1/admin-page/sales/trend?${params.toString()}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// ==========================================
// 매출 태그 API (Sales Tag)
// ==========================================
// 결제 1건에 태그 1개. 지정하지 않은 결제는 자동 규칙(시스템 결제=마크픽, 수동 결제=채널)으로 표시된다
// 추가·수정·삭제·지정은 400/404/409 를 그대로 throw 하므로 호출자가 response.data.detail 을 보여준다
export const getSalesTags = async () => {
  try {
    return await axios.get(`/v1/admin-page/sales/tags`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

export const createSalesTag = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/sales/tags`, data, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

export const updateSalesTag = async (id, data) => {
  try {
    return await axios.put(`/v1/admin-page/sales/tags/${id}`, data, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

// 기본 태그 삭제는 409. 사용 중인 결제는 '기타'로 이관되고 moved_count 로 건수가 온다
export const deleteSalesTag = async (id) => {
  try {
    return await axios.delete(`/v1/admin-page/sales/tags/${id}`, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

// 결제 1건의 태그 지정 { payment_type, payment_pk, tag_id }
export const assignSalesPaymentTag = async (data) => {
  try {
    return await axios.put(`/v1/admin-page/sales/payments/tag`, data, header());
  } catch (error) {
    return await blogErrorHandling(error);
  }
};

// 월별 태그 비중
//   metric: 'gross' | 'net'
//   응답 { meta, data: { year, metric, tags: [{ id, name, color }],
//     months: [{ month, total, by_tag: [{ tag_id, amount, count }] }], year_total: { total, by_tag } } }
export const getSalesBreakdown = async (year, service = "all", metric = "gross") => {
  try {
    const params = new URLSearchParams({ year, service, metric });
    return await axios.get(`/v1/admin-page/sales/breakdown?${params.toString()}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 고객별 매출 (기간 파라미터는 통계 API 와 동일: period=month|all|custom)
//   응답 { meta, data: { summary: { customer_count, total_gross, top10_gross, repeat_customer_count },
//     pagination, items: [{ customer_key, user_pk, user_name, user_id, contact, is_manual,
//     count, gross, net, first_paid_at, last_paid_at, top_tag }] } }
const buildSalesPeriodParams = ({ period, year, month, startDate, endDate }) => {
  const params = new URLSearchParams({ period });
  if (period === "month") {
    params.append("year", year);
    params.append("month", month);
  } else if (period === "custom") {
    params.append("start_date", startDate);
    params.append("end_date", endDate);
  }
  return params;
};

export const getSalesCustomers = async (filter, { service = "all", keyword = "", sort = "gross", order = "desc", page = 1, limit = 20 } = {}) => {
  try {
    const params = buildSalesPeriodParams(filter);
    params.append("service", service);
    if (keyword) params.append("keyword", keyword);
    params.append("sort", sort);
    params.append("order", order);
    params.append("page", page);
    params.append("limit", limit);
    return await axios.get(`/v1/admin-page/sales/customers?${params.toString()}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 고객 결제 이력. customer_key 는 'user:123' 또는 'manual:01012345678' 형식
export const getSalesCustomerPayments = async (customerKey, filter, { service = "all", page = 1, limit = 20 } = {}) => {
  try {
    const params = buildSalesPeriodParams(filter);
    params.append("service", service);
    params.append("page", page);
    params.append("limit", limit);
    return await axios.get(
      `/v1/admin-page/sales/customers/${encodeURIComponent(customerKey)}/payments?${params.toString()}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// ==========================================
// 수동 결제 API (Manual Payment)
// ==========================================

// 수동 결제 등록
export const createSalesManual = async (data) => {
  try {
    return await axios.post(`/v1/admin-page/sales/manual`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 수동 결제 조회 (수정 모달용)
export const getSalesManual = async (id) => {
  try {
    return await axios.get(`/v1/admin-page/sales/manual/${id}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 수동 결제 수정
export const updateSalesManual = async (id, data) => {
  try {
    return await axios.put(`/v1/admin-page/sales/manual/${id}`, data, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// 수동 결제 삭제
export const deleteSalesManual = async (id) => {
  try {
    return await axios.delete(`/v1/admin-page/sales/manual/${id}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// ==========================================
// 통계 API (Statistics)
// ==========================================
// 기간 필터 파라미터 규격
//   period : 'month' | 'all' | 'custom'
//   month  → year, month
//   custom → start_date(YYYY-MM-DD), end_date(YYYY-MM-DD)
//
// 가입자 수 응답 형태
//   { total: number, period_label: string, breakdown?: [{ label, count }] }
// 설문 통계 응답 형태
//   {
//     inflow:    { total: number, items: [{ label, count }] },  // 유입 경로
//     user_type: { total: number, items: [{ label, count }] },  // 사용자 유형
//     interest:  { total: number, items: [{ label, count }] },  // 관심 서비스
//   }
const buildStatsParams = ({ period, year, month, startDate, endDate }) => {
  const params = new URLSearchParams();
  params.append("period", period);
  if (period === "month") {
    params.append("year", year);
    params.append("month", month);
  } else if (period === "custom") {
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
  }
  return params.toString();
};

// 가입자 수 통계 조회
export const getSignupStats = async (filter) => {
  try {
    return await axios.get(
      `/v1/admin-page/stats/signups?${buildStatsParams(filter)}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 설문조사 통계 조회 (유입경로 / 사용자유형 / 관심서비스)
export const getSurveyStats = async (filter) => {
  try {
    return await axios.get(
      `/v1/admin-page/stats/survey?${buildStatsParams(filter)}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 설문 항목 상세 조회 (예: 유입경로=네이버 검색 응답자 명단)
//   type  : 'inflow' | 'user_type' | 'interest'
//   value : 선택한 항목명 (예: "네이버 검색")
//   응답 형태 { total: number, items: [{ user_name, user_id, email, created_at, inflow, user_type, interest }] }
export const getSurveyDetail = async (type, value, filter, { page = 1, limit = 20 } = {}) => {
  try {
    const params = buildStatsParams(filter);
    return await axios.get(
      `/v1/admin-page/stats/survey/detail?type=${type}&value=${encodeURIComponent(
        value
      )}&page=${page}&limit=${limit}&${params}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// 설문 분류별 매출/순매출 조회 (결제일 기준)
//   응답 형태 {
//     gross_total, net_total, payment_count, payer_count,
//     inflow|user_type|interest: {
//       items: [{ label, gross, net, payment_count, payer_count, unmatched }]
//     },
//   }
//   unmatched=true 항목은 "설문 미응답" / "수동 결제"
export const getSurveyRevenueStats = async (filter) => {
  try {
    return await axios.get(
      `/v1/admin-page/stats/survey/revenue?${buildStatsParams(filter)}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// UTM 유입 통계 조회
//   기간 파라미터는 기존 통계와 동일 (period=month|all|custom)
//   campaigns 는 page/limit 서버 페이지네이션 (summary/sources 는 항상 전체)
//   응답 형태 {
//     summary: {
//       visits: number,          // UTM 방문 수
//       signups: number,         // UTM 경유 가입 수
//       total_signups: number,   // 기간 내 전체 가입 수 (비율 계산용)
//       conversion: number,      // 방문→가입 전환율(%)
//     },
//     sources:   [{ source, visits, signups }],
//     campaigns: {
//       total: number,
//       items: [{ source, medium, campaign, visits, signups }],
//     },
//   }
export const getUtmStats = async (filter, { page = 1, limit = 10 } = {}) => {
  try {
    const params = new URLSearchParams(buildStatsParams(filter));
    params.append("page", page);
    params.append("limit", limit);
    return await axios.get(
      `/v1/admin-page/stats/utm?${params.toString()}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// UTM 캠페인별 가입자 명단 조회
//   target: { source, medium, campaign }
//   응답 형태 { total: number, items: [{ user_name, user_id, email, created_at }] }
export const getUtmDetail = async (target, filter, { page = 1, limit = 20 } = {}) => {
  try {
    const params = new URLSearchParams(buildStatsParams(filter));
    params.append("source", target.source || "");
    params.append("medium", target.medium || "");
    params.append("campaign", target.campaign || "");
    params.append("page", page);
    params.append("limit", limit);
    return await axios.get(
      `/v1/admin-page/stats/utm/detail?${params.toString()}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// UTM 배포 링크 등록
//   payload: { url, source, medium, campaign, posts: [{ memo, post_url }] }
export const createUtmLink = async (payload) => {
  try {
    return await axios.post(`/v1/admin-page/stats/utm/links`, payload, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// UTM 배포 링크 목록 조회
//   응답 형태 { total, items: [{ id, url, source, medium, campaign, posts: [{ id, memo, post_url, admin_id, created_at }], admin_id, created_at }] }
export const getUtmLinks = async ({ source = "", campaign = "", keyword = "", page = 1, limit = 10 } = {}) => {
  try {
    const params = new URLSearchParams({ source, campaign, keyword, page, limit });
    return await axios.get(
      `/v1/admin-page/stats/utm/links?${params.toString()}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// UTM 배포 링크 수정 (배포처 메모/게시물 URL만)
export const updateUtmLink = async (linkId, payload) => {
  try {
    return await axios.put(`/v1/admin-page/stats/utm/links/${linkId}`, payload, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// UTM 배포 링크 삭제
export const deleteUtmLink = async (linkId) => {
  try {
    return await axios.delete(`/v1/admin-page/stats/utm/links/${linkId}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

// UTM 링크 배포처 추가
//   payload: { memo, post_url }
export const addUtmLinkPost = async (linkId, payload) => {
  try {
    return await axios.post(
      `/v1/admin-page/stats/utm/links/${linkId}/posts`,
      payload,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// UTM 링크 배포처 수정
export const updateUtmLinkPost = async (linkId, postId, payload) => {
  try {
    return await axios.put(
      `/v1/admin-page/stats/utm/links/${linkId}/posts/${postId}`,
      payload,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

// UTM 링크 배포처 삭제 (마지막 한 건은 삭제 불가)
export const deleteUtmLinkPost = async (linkId, postId) => {
  try {
    return await axios.delete(
      `/v1/admin-page/stats/utm/links/${linkId}/posts/${postId}`,
      header()
    );
  } catch (error) {
    return await errorHandling(error);
  }
};

export const getPatentDesignRequestList = async ({ page, limit, status, keyword, requestType }) => {
  try {
    return await axios.get(`/v1/admin-page/patent-design`, {
      params: { page, limit, status, keyword, request_type: requestType },
      ...header(),
    });
  } catch (error) {
    return await errorHandling(error);
  }
};

export const getPatentDesignRequestDetail = async (id) => {
  try {
    return await axios.get(`/v1/admin-page/patent-design/${id}`, header());
  } catch (error) {
    return await errorHandling(error);
  }
};

export const updatePatentDesignRequestStatus = async (id, status) => {
  try {
    return await axios.post(
      `/v1/admin-page/patent-design/${id}/status`,
      { status },
      header()
    );
  } catch (error) {
    return (await errorHandling(error)) ?? error?.response?.data?.detail;
  }
};

const parseBlobErrorData = async (error) => {
  if (error.response?.data instanceof Blob) {
    try {
      error.response.data = JSON.parse(await new Response(error.response.data).text());
    } catch {}
  }
};

const withDetail = async (error) =>
  (await errorHandling(error)) ?? error?.response?.data?.detail;

export const downloadPatentDesignRequestFile = async (fileId) => {
  try {
    return await axios.get(`/v1/admin-page/patent-design/file/${fileId}`, {
      ...header(),
      responseType: "blob",
    });
  } catch (error) {
    await parseBlobErrorData(error);
    return await errorHandling(error);
  }
};

export const downloadPatentDesignDocument = async (documentId) => {
  try {
    return await axios.get(`/v1/admin-page/patent-design/document/${documentId}`, {
      ...header(),
      responseType: "blob",
    });
  } catch (error) {
    await parseBlobErrorData(error);
    return await errorHandling(error);
  }
};

export const updatePatentDesignRequest = async (id, body) => {
  try {
    return await axios.patch(`/v1/admin-page/patent-design/${id}`, body, header());
  } catch (error) {
    return await withDetail(error);
  }
};

export const createPatentDesignNotice = async (id, { content, files = [] }) => {
  const formData = new FormData();
  formData.append("content", content);
  files.forEach((file) => formData.append("files", file));
  try {
    return await axios.post(
      `/v1/admin-page/patent-design/${id}/notice`,
      formData,
      formDataHeader()
    );
  } catch (error) {
    return await withDetail(error);
  }
};

export const deletePatentDesignNotice = async (noticeId) => {
  try {
    return await axios.delete(`/v1/admin-page/patent-design/notice/${noticeId}`, header());
  } catch (error) {
    return await withDetail(error);
  }
};

export const createPatentDesignDocument = async (id, { title, file }) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("file", file);
  try {
    return await axios.post(
      `/v1/admin-page/patent-design/${id}/document`,
      formData,
      formDataHeader()
    );
  } catch (error) {
    return await withDetail(error);
  }
};

export const deletePatentDesignDocument = async (documentId) => {
  try {
    return await axios.delete(`/v1/admin-page/patent-design/document/${documentId}`, header());
  } catch (error) {
    return await withDetail(error);
  }
};

export const createPatentDesignDocumentRequest = async (id, { title, description }) => {
  try {
    return await axios.post(
      `/v1/admin-page/patent-design/${id}/document-request`,
      { title, description },
      header()
    );
  } catch (error) {
    return await withDetail(error);
  }
};

export const closePatentDesignDocumentRequest = async (documentRequestId) => {
  try {
    return await axios.patch(
      `/v1/admin-page/patent-design/document-request/${documentRequestId}`,
      { status: "closed" },
      header()
    );
  } catch (error) {
    return await withDetail(error);
  }
};

export const updateAddedPaymentServiceType = async (addedId, serviceType) => {
  try {
    return await axios.patch(
      `/v1/admin-page/added-payment/${addedId}/service-type`,
      { service_type: serviceType },
      header()
    );
  } catch (error) {
    return await withDetail(error);
  }
};

